import { BreakpointService } from '@/common/services/breakpoint/breakpoint.service';
import { Component, Input } from '@angular/core';

export interface PromotionHeroData {
    img?: string | null;
    imgMobile?: string | null;
    isVideo?: boolean;
    isVideoMobile?: boolean;
    video?: string | null;
    videoMobile?: string | null;
    isBackground?: boolean;
    isBackgroundMobile?: boolean;
    background?: string | null;
    backgroundMobile?: string | null;
}

@Component({
    selector: 'fe-promotion-hero',
    templateUrl: './promotion-hero.component.html',
    styleUrls: ['./promotion-hero.component.scss'],
})
export class PromotionHeroComponent {
    @Input() promotion?: PromotionHeroData | null;

    constructor(public breakpoint: BreakpointService) {}

    public isVideo(): boolean {
        const isVideo = !!this.promotion?.isVideo;
        const isVideoMobile = !!this.promotion?.isVideoMobile;
        return (
            (isVideo && !this.breakpoint.isMobile()) ||
            (isVideoMobile && this.breakpoint.isMobile())
        );
    }

    public videoSource(): string | null | undefined {
        return this.breakpoint.isMobile()
            ? this.promotion?.videoMobile
            : this.promotion?.video;
    }

    public isBackground(): boolean {
        const isBackground = !!this.promotion?.isBackground;
        const isBackgroundMobile = !!this.promotion?.isBackgroundMobile;
        return (
            (isBackground && !this.breakpoint.isMobile()) ||
            (isBackgroundMobile && this.breakpoint.isMobile())
        );
    }

    public hasMedia(): boolean {
        return this.isVideo() || this.isBackground() || !!this.promotion?.img;
    }

    public isEmpty(): boolean {
        return !this.hasMedia();
    }

    public backgroundUrl(): string | null | undefined {
        if (!this.isBackground()) {
            return null;
        }
        return this.breakpoint.isMobile()
            ? this.promotion?.backgroundMobile
            : this.promotion?.background;
    }
}
